export default __webpack_public_path__ + "static/media/main-tm-background.76998eb1.jpg";